// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "dialogContent-2fuev";
var _3 = "header-369Y0";
export { _1 as "__esModule", _2 as "dialogContent", _3 as "header" }
export default { "__esModule": _1, "dialogContent": _2, "header": _3 }
